import { render, staticRenderFns } from "./ShowActiveValue.vue?vue&type=template&id=55524798"
import script from "./ShowActiveValue.vue?vue&type=script&lang=js"
export * from "./ShowActiveValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports